import { render, staticRenderFns } from "./23_main.vue?vue&type=template&id=51516314&"
import script from "./23_main.vue?vue&type=script&lang=js&"
export * from "./23_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports